var b = "/static/d832fbb1cae7e62f.png";

export { b as default };
//# sourceMappingURL=daily_rakeback.png.js.map
